import { Flex, Text } from 'components'
import { useEffect } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router'
import { useBreakpoint, useDisclosure, usePrefCurrentWorkspace } from 'utils'
import ManageToolDrawer from '../components/toolContent/ManageToolDrawer'
import ToolContentList from '../components/toolContent/ToolContentList'
import { RoutePath } from '../utils/routing'
import { useTools } from '../utils/toolUtils'

export default function ToolContentPage() {
  const [workspaceId] = usePrefCurrentWorkspace()
  const navigate = useNavigate()
  const { id } = useParams()
  const { onClose, onOpen, open } = useDisclosure()
  const isMobile = useBreakpoint() < 1

  const { tools, status } = useTools()

  useEffect(() => {
    if (id) onOpen()
    else onClose()
  }, [id])

  function handleOnClose() {
    navigate(generatePath(RoutePath.Tool, { workspaceId: workspaceId! }))
  }

  return (
    <Flex
      direction="column"
      gap={4}
      flex="auto"
      p={isMobile ? 4 : 0}
      overflowY="auto"
      overflowX="hidden"
    >
      <Text textStyle="h3" pt={2}>
        Tool Content
      </Text>

      <ToolContentList status={status} tools={tools} />
      <ManageToolDrawer open={open} id={id} onClose={handleOnClose} />
    </Flex>
  )
}
